var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconEnrollment = function SvgIconEnrollment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55.625 55.625"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.274 17.877v-.004a1.968 1.968 0 0 0-.173-.484c-.019-.04-.04-.077-.061-.115a2.02 2.02 0 0 0-.313-.424L33.463.586a1.93 1.93 0 0 0-.424-.313c-.038-.021-.074-.042-.113-.061A1.996 1.996 0 0 0 32.049 0H7.312a2 2 0 0 0-2 2v51.625a2 2 0 0 0 2 2h41a2 2 0 0 0 2-2V18.264a2 2 0 0 0-.038-.387zm-6.791-1.613h-9.435V6.828l4.718 4.718 4.717 4.718zM9.312 51.625V4h20.736v14.264a2 2 0 0 0 2 2h14.264v31.361h-37z"
  })));
};

export default __webpack_public_path__ + "static/media/icon-enrollment.32cf21fe.svg";
export { SvgIconEnrollment as ReactComponent };